import { render, staticRenderFns } from "./HomeView.vue?vue&type=template&id=a8a5872a&scoped=true"
import script from "./HomeView.vue?vue&type=script&lang=js"
export * from "./HomeView.vue?vue&type=script&lang=js"
import style0 from "./HomeView.vue?vue&type=style&index=0&id=a8a5872a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a5872a",
  null
  
)

export default component.exports